export const GoogleMapApiConfig = 'AIzaSyCCycTXV27NRliBbo-1mFFKsxuDu1t_aso';